/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_DescInputs */

const en_mk_model_desc = /** @type {(inputs: Mk_Model_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every skill already knows which model fits its task best, at the lowest cost. An internal router picks it automatically, your team never needs to learn model jargon, and the cost per task shows up in Rupiah.`)
};

const id_mk_model_desc = /** @type {(inputs: Mk_Model_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiap skill sudah tahu model mana yang paling pas dan paling hemat untuk tugasnya. Router internal otomatis memilihkan modelnya, timmu tidak perlu paham istilah model, dan biaya per tugas otomatis tampil dalam Rupiah.`)
};

/**
* | output |
* | --- |
* | "Every skill already knows which model fits its task best, at the lowest cost. An internal router picks it automatically, your team never needs to learn model..." |
*
* @param {Mk_Model_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_desc = /** @type {((inputs?: Mk_Model_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_desc(inputs)
	return en_mk_model_desc(inputs)
});